import { styled } from '@clickcease/cc-client-components-lib'

export const GlobalModalWrapperStyled = styled('div', {})
